import React, {
  useRef,
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
  useMemo,
} from "react";
import SearchPanel from "../../../../../widgets/SearchPanel";
import { fnGetDataSet, fnSave } from "@shared/api/restApi";
import { applySlip, getInitFormData } from "@shared/utils/CommonUtils";
import { global } from "@shared/libs/Global";
import SnGrid from "@shared/components/GridV2/SnGrid";
import { menuInfo } from "@shared/type/CommonType";
import SnCodeBox from "@shared/components/SnCodeBox";
import SnComboBox from "@shared/components/SnComboBox";
import SnLabel from "@shared/components/SnLabel";
import SnDateBox from "@shared/components/SnDateBox";
import SnButton from "@shared/components/SnButton";
import SnResizeBar from "@shared/components/SnResizeBar";
import { dateToString } from "@shared/utils/DateUtils";
import SnTextBox from "@shared/components/SnTextBox";
import SnNumberBox from "@shared/components/SnNumberBox";
import { showDialog } from "@widgets/CommonDialog";

interface Props {
  Menuprops: menuInfo;
}
interface CodeValue {
  code: string;
  name: string;
}

const SN_PRD_EQP_REG_001 = forwardRef(({ Menuprops }: Props, ref) => {
  const gridRefs = useRef<{ [key: string]: React.RefObject<any> }>({
    grid1: React.createRef(),
  });
  const { userInfo, config } = global();

  const searchRef = useRef<any>(null);
  const [formData, setFormData] = useState<any>();
  const [formControlData, setFormControlData] = useState<any[]>([]);
  const [columns, setColums] = useState<any>({
    grid1: [],
  });
  const [dataSources, setDataSources] = useState<any>({
    grid1: [],
  });
  const [dateBox, setDateBox] = useState<string>(dateToString(new Date()));
  const [codeEmp, setCodeEmp] = useState<CodeValue>({
    code: userInfo.cd_emp || "",
    name: userInfo.nm_emp || "",
  });
  const [selectedValue, setSelectedValue] = useState<string>("01");
  const [selectedCdExam, setSelectedCdExam] = useState<string>("");
  const [selectedDcResult, setSelectedDcResult] = useState<string>("");
  const [noBox1, setNoBox1] = useState<number>(0);
  const cdExamRef = useRef<HTMLInputElement>(null);
  const [cdExamKey, setCdExamKey] = useState(0);

  useEffect(() => {
    const fetchform = async () => {
      try {
        const rtn: any = await getInitFormData({});
        setFormData(rtn.formData);
        setFormControlData(rtn.formControlData);
        setColums({
          grid1: rtn.grid.grid1,
        });
      } catch (error) {}
    };
    fetchform();
  }, []);

  useImperativeHandle(ref, () => ({
    onSearch,
    onSave,
  }));

  //region OnSearch
  const onSearch = async () => {
    try {
      const modifiedRowsH = gridRefs.current["grid1"].current.getChange();
      if (modifiedRowsH.modifiedRowcount > 0) {
        const confirm = await showDialog(
          "confirm",
          "수정된 내용이 있습니다. 저장하시겠습니까?"
        );
        if (confirm) {
          const isSaved: any = await onSave();
          if (!isSaved) return;
        }
      }
      gridRefs.current["grid1"].current.resetUpdate();
      const formData = searchRef.current.getFormdata();

      const param = {
        id: "sn_prd_eqp_reg_001_01",
        params: {
          ...formData,
          chk: formData.cd_euqip && formData.cd_euqip.trim() !== "" ? 1 : 0,
        },
      };

      const data: any = await fnGetDataSet(param);
      setDataSources({
        grid1: data[0],
      });
      setSelectedCdExam("");
      setNoBox1(0);
      setSelectedDcResult("");
    } catch (error) {}
  };

  const onSave = async () => {
    try {
      gridRefs.current["grid1"].current.stopEditing();

      const requiredValuesCheckH =
        gridRefs.current["grid1"].current.requiredValuesCheck();
      if (!requiredValuesCheckH) return false;

      const maintenance = gridRefs.current["grid1"].current.getChange();

      if (maintenance.modifiedRowcount === 0) {
        await showDialog("alter", "변경된 내용이 없습니다.");
        return false;
      }

      const saveData = {
        equip_maintenance: maintenance,
      };
      const ok = await fnSave("SN_PRD_EQP_REG_001_SAVE_01", saveData);
      if (!ok) return false;

      gridRefs.current["grid1"].current.resetUpdate();
      return true;
    } catch (error: any) {
      gridRefs.current["grid1"].current.resetUpdate(true);
      return false;
    }
  };

  // useEffect(() => {
  //   if (selectedCdExam === "") {
  //     cdExamRef.current?.blur();
  //   } else {
  //     cdExamRef.current?.focus();
  //   }
  // }, [cdExamKey]);

  const applyExamToGrid = (cdExam: string) => {
    const rowCount = gridRefs.current["grid1"].current.getDisplayedRowCount();
    if (rowCount === 0) return;

    for (let i = 0; i < rowCount; i++) {
      const rowNodeAtIndex =
        gridRefs.current["grid1"].current.getRowNodeAtIndex(i);
      if (!rowNodeAtIndex) continue;

      if (rowNodeAtIndex.data?.cd_exam !== cdExam) continue;

      if (rowNodeAtIndex.data?.dt_exam) {
        continue;
      }
      rowNodeAtIndex.setDataValue("cd_exam", cdExam);
      rowNodeAtIndex.setDataValue("dt_exam", dateBox);
      rowNodeAtIndex.setDataValue("cd_emp", codeEmp.code);
      rowNodeAtIndex.setDataValue("nm_emp", codeEmp.name);
      rowNodeAtIndex.setDataValue("cd_result", selectedValue);
      rowNodeAtIndex.setDataValue("qt_exam", noBox1);
      rowNodeAtIndex.setDataValue("qt_exam2", noBox1);
      rowNodeAtIndex.setDataValue("qt_exam3", noBox1);
      rowNodeAtIndex.setDataValue("dc_result", selectedDcResult);
      break;
    }
  };

  const onGrid1BtnsClick = async (id: string) => {
    switch (id) {
      case "btnGoodapp": {
        if (!selectedCdExam) return;

        const rowCount =
          gridRefs.current["grid1"].current.getDisplayedRowCount();
        if (rowCount === 0) return;

        for (let i = 0; i < rowCount; i++) {
          const rowNodeAtIndex =
            gridRefs.current["grid1"].current.getRowNodeAtIndex(i);
          if (!rowNodeAtIndex) continue;

          if (rowNodeAtIndex.data?.cd_exam !== selectedCdExam) continue;

          if (rowNodeAtIndex.data?.dt_exam) {
            continue;
          }
          rowNodeAtIndex.setDataValue("cd_exam", selectedCdExam);
          rowNodeAtIndex.setDataValue("dt_exam", dateBox);
          rowNodeAtIndex.setDataValue("cd_emp", codeEmp.code);
          rowNodeAtIndex.setDataValue("nm_emp", codeEmp.name);
          rowNodeAtIndex.setDataValue("cd_result", selectedValue);
          rowNodeAtIndex.setDataValue("qt_exam", noBox1);
          rowNodeAtIndex.setDataValue("qt_exam2", noBox1);
          rowNodeAtIndex.setDataValue("qt_exam3", noBox1);
          rowNodeAtIndex.setDataValue("dc_result", selectedDcResult);
        }
        setSelectedCdExam("");
        setNoBox1(0);
        setSelectedDcResult("");
        break;
      }

      default:
        break;
    }
  };

  const cdExamChanged = async (value: string) => {
    setSelectedCdExam(value);
    applyExamToGrid(value);
    // setSelectedCdExam("");
    // setCdExamKey((prev) => prev + 1);
  };

  const empValueChanged = async (code: string, name: string, rowData?: any) => {
    setCodeEmp({ code: code, name: name });
  };

  const dateValueChanged = async (value: string) => {
    setDateBox(value);
  };

  const dcResultChanged = async (value: string) => {
    setSelectedDcResult(value);
  };

  const onValueChanged = async (value: string) => {
    setSelectedValue(value);
  };

  const vcRadioN1 = async (id: number) => {
    setNoBox1(id);
  };

  const grids = useMemo(
    () => ({
      grid1: {
        columns: columns.grid1,
        dataSource: dataSources.grid1,
        // events: {
        //   onCellValueChanged: onCellValueChanged2,
        // },
      },
    }),
    [columns, dataSources]
  );

  return (
    <div className="h-full flex flex-col">
      <div className="mb-1">
        <SearchPanel
          ref={searchRef}
          data={formData}
          controls={formControlData}
        ></SearchPanel>
      </div>
      <div className="flex flex-col gap-2 mb-3">
        {/* 1번째 줄 */}
        <div className="grid grid-cols-[100px_180px_100px_180px_100px_180px_100px] gap-x-3 gap-y-2">
          {/* ===== 1번째 줄 ===== */}
          <SnLabel text="점검항목" type="string" />
          <SnTextBox
            key={cdExamKey}
            inputRef={cdExamRef}
            defaultValue={selectedCdExam}
            onValueChanged={cdExamChanged}
          />

          <SnLabel text="점검일" type="string" />
          <SnDateBox defaultValue={dateBox} onValueChanged={dateValueChanged} />

          <SnLabel text="점검자" type="string" />
          <SnCodeBox
            code="POPUP_EMP"
            defaultValue={{
              code: codeEmp.code,
              name: codeEmp.name,
            }}
            onValueChanged={empValueChanged}
            isEditable={true}
          />

          <SnButton
            text="일괄적용"
            onClick={() => onGrid1BtnsClick("btnGoodapp")}
          />

          {/* ===== 2번째 줄 ===== */}
          <SnLabel text="판정" type="string" />
          <SnComboBox
            defaultValue={selectedValue}
            code="PRD304"
            isEditable={true}
            onValueChanged={onValueChanged}
          />

          <SnLabel text="측정치" type="string" />
          <SnNumberBox defaultValue={noBox1} onValueChanged={vcRadioN1} />

          <SnLabel text="점검결과" type="string" />
          <SnTextBox
            defaultValue={selectedDcResult}
            onValueChanged={dcResultChanged}
          />

          {/* 버튼 자리 맞춤용 */}
          <div />
        </div>
      </div>
      <SnResizeBar direction={"height"} id="panel1" orgSize="70.5%">
        <SnGrid
          ref={gridRefs.current["grid1"]}
          columnConfig={grids.grid1.columns} // 컬럼 설정 전달
          rowData={grids.grid1.dataSource} // Datasource
          etcProps={{ rowSelection: "multiple" }}
        />
      </SnResizeBar>
    </div>
  );
});

export default SN_PRD_EQP_REG_001;
